import React from "react";
import DominicanFlag from "./DominicanFlag";

// Big "banner" style Dominican flag that hangs from a pole and swings.
// Use absolute positioning where placed.
const SwingingFlag = ({ size = "lg" }) => {
    const dims = {
        sm: { w: 80, h: 56, pole: 90 },
        md: { w: 120, h: 84, pole: 130 },
        lg: { w: 180, h: 120, pole: 200 },
        xl: { w: 240, h: 160, pole: 260 },
    }[size] || { w: 180, h: 120, pole: 200 };

    return (
        <div
            data-testid="swinging-flag"
            className="flag-swing pointer-events-none select-none"
            style={{ width: dims.w, height: dims.pole + 20 }}
            aria-hidden="true"
        >
            {/* Pole anchor / cap */}
            <div className="relative mx-auto" style={{ width: 8, height: 8 }}>
                <div
                    className="absolute left-1/2 -translate-x-1/2 -top-1 rounded-full"
                    style={{ width: 14, height: 14, background: "#A89A82" }}
                />
            </div>
            {/* Pole */}
            <div
                className="mx-auto"
                style={{
                    width: 4,
                    height: dims.pole - dims.h - 12,
                    background:
                        "linear-gradient(to right, #5E2A0A, #A89A82 40%, #823A0E)",
                    borderRadius: 2,
                }}
            />
            {/* Tie ring */}
            <div
                className="mx-auto rounded-full"
                style={{ width: 10, height: 10, background: "#A89A82", marginTop: -4 }}
            />
            {/* Flag */}
            <div
                className="flag-wave relative mx-auto shadow-2xl"
                style={{
                    width: dims.w,
                    height: dims.h,
                    marginTop: -2,
                    borderRadius: 2,
                    overflow: "hidden",
                    filter: "drop-shadow(0 8px 12px rgba(0,0,0,0.18))",
                }}
            >
                <DominicanFlag
                    style={{ width: "100%", height: "100%", display: "block" }}
                />
                {/* fabric shading */}
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        background:
                            "linear-gradient(90deg, rgba(0,0,0,0.18) 0%, transparent 20%, transparent 80%, rgba(255,255,255,0.12) 100%)",
                    }}
                />
            </div>
        </div>
    );
};

export default SwingingFlag;
